import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import { Button, Grid, TextField, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import accredhospilogo from '../../assets/images/accredhospi-logo.png'
import { connect } from 'react-redux';
import { SET_REFERENTIEL, SET_INFOS } from '../../state/action/action';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
		maxWidth: '90vw',
  },
  gridMain: {
    display: 'flex',
		flexDirection: 'column',
    alignItems: 'center',
		justifyItems: 'center',
  },
	btn: {
      '& .MuiButton-label' :{
          textTransform :'none'
      }
  }
}));


function Contact({referentiel, dispatch}) {
	const classes = useStyles()

  return (
	<div className='Manuel'>
		<div className={classes.root}>
		<Grid container direction='column' alignItems='center' justify='center'>
			<Grid container item direction='column' alignItems='center' justify='center' style={{width: '350px', height: '350px',}} >
				<img src={accredhospilogo} alt='Logo AccredHospi' style={{width: '334px', height: '279px'}} />
			</Grid>
		</Grid>
		<Grid container item  className={classes.gridMain} spacing={3} alignItems='center' justify='center' direction='column'>
			
			<Button variant='outlined' color='secondary' href='https://www.accredhospi-benin.com/nous-contacter' className={classes.btn}>
				Nous contacter
			</Button>

			<Link to='/' style={{ textDecoration: 'none', color: 'inherit', marginTop: '5%', marginBottom: '15%' }}>
				<Button variant="outlined" color="primary" className={classes.btn}>
					Accueil
				</Button>
			</Link>
		</Grid>
	</div>
	</div>
	)
}

const mapStateToProps = (state) => {
	return {
		referentiel: state.setReferentielReducer.referentiel
	}
}

export default connect(mapStateToProps)(Contact);
